/* eslint @typescript-eslint/ban-types: 0 */
import type { IncomingMessage as IncomingMessageHttp } from 'http'
import type { NextApiRequestCookies } from 'next/dist/server/api-utils'
import { Environment } from '../_kernel/Environment'

import { z } from 'zod'

export type IncomingMessage = IncomingMessageHttp & {
  cookies: NextApiRequestCookies
}
// Define the schema for known config properties
const KnownConfigSchema = z.object({
  API_GATEWAY: z.string(),
  API_GATEWAY_MAP: z.map(z.string(), z.string()).optional(),
  ENVIRONMENT: z.enum(['development', 'production', 'test']),
  FRAMEWORK_REQUEST: z.custom<IncomingMessage>().optional(),
  COOKIES_STRING: z.string().optional(),
  IMAGE_SERVICE: z.string(),
  STATICS_HOST: z.string(),
  BANNERS_FILE_NAME: z.string().optional().default('banners.json'),
})

// Infer the type from the schema
export type KnownConfig = z.infer<typeof KnownConfigSchema>
export type KnownConfigKeys = keyof KnownConfig
export type AllowedConfigKeys = KnownConfigKeys | (string & {})

// Complete config schema that allows additional properties
const ConfigSchema = KnownConfigSchema.catchall(z.unknown())

export type Base = KnownConfig & { [key: string]: unknown }

export class Config {
  public config: Base

  static create(base: Base) {
    return new Config(base)
  }

  constructor(base: Base) {
    ConfigSchema.parse(base)
    this.config = {
      ...base,
    }
  }

  get<K extends AllowedConfigKeys>(key: K): K extends KnownConfigKeys ? KnownConfig[K] : unknown {
    if (key === 'API_GATEWAY' && this.config.API_GATEWAY_MAP && Environment.create().isBrowser()) {
      const mappedValue = this.config.API_GATEWAY_MAP.get(window.location.hostname)
      return mappedValue ?? (this.config.API_GATEWAY as any)
    }

    return this.config[key] as any
  }

  set<K extends AllowedConfigKeys>(
    key: K,
    value: K extends KnownConfigKeys ? KnownConfig[K] : unknown
  ): void {
    // Lo que viene siendo matar moscas a cañonazos
    ;(this.config as Record<string, unknown>)[key as string] = value
  }

  has<K extends AllowedConfigKeys>(key: K): boolean {
    return this.config[key] !== undefined
  }
}
